export enum ThreadStyle {
    Default = "default",
    CommentsAbove = "commentsAbove"
}
